import {
  SET_MEMBER_DATA,
  SET_MEMBERS_DATA,
  SET_MEMBER_COUNT,
} from "../types/types";
export const setMemberData = (value) => {
  return {
    type: SET_MEMBER_DATA,
    payload: { data: value },
  };
};
export const setShowVoidedReason = (value) => {
  return {
    type: "SET_SHOW_VOIDED_REASON",
    payload: { data: value },
  };
};

export const setMemberCount = (value) => {
  return {
    type: SET_MEMBER_COUNT,
    payload: { data: value },
  };
};
export const setMemberActionsPermissions = (value) => {
  return {
    type: "SET_MEMBER_ACTION_PERMISSIONS",
    payload: { data: value },
  };
};

export const setformMemberProps = (value) => {
  return {
    type: "SET_EDIT_FORM_PROPS",
    payload: { data: value },
  };
};
export const setMemberInfoLimit = (value) => {
  return {
    type: "SET_DATA_LIMIT",
    payload: { data: value },
  };
};
export const setMemberInfoCount = (value) => {
  return {
    type: "SET_DATA_COUNT",
    payload: { data: value },
  };
};
export const setMemberInfoPage = (value) => {
  return {
    type: "SET_DATA_PAGE",
    payload: { data: value },
  };
};
export const setMemberInfoData = (value) => {
  return {
    type: "SET_DATA",
    payload: { data: value },
  };
};
export const setExistingMember = (value) => {
  console.log({ value });
  return {
    type: "SET_EXISTING_MEMBER",
    payload: { data: value },
  };
};
export const setShowExistingMemberModal = (value) => {
  console.log("here");
  return {
    type: "SET_SHOW_EXISTING_MEMBER_MODAL",
    payload: { data: value },
  };
};
export const setShowDeletedMemberModal = (value) => {
  console.log("here");
  return {
    type: "SET_SHOW_DELETED_MEMBER_MODAL",
    payload: { data: value },
  };
};
export const setMemberInfoId = (value) => {
  return {
    type: "SET_MEMBER_INFO_ID",
    payload: { data: value },
  };
};
export const setActiveMember = (value) => {
  return {
    type: "SET_ACTIVE_MEMBER",
    payload: { data: value },
  };
};
export const resetMemberData = (value) => {
  return {
    type: "RESET_ACTIVE_MEMBER",
  };
};
// member booking list
export const setMemberBookingList = (value) => {
  return {
    type: "SET_M_BOOKING_LIST",
    payload: { data: value },
  };
};
export const setBookingListLoading = (value) => {
  return {
    type: "SET_MEMBER_LOADING_LIST",
    payload: { data: value },
  };
};
export const setGymSubscriptionLoading = (value) => {
  return {
    type: "SET_MEMBER_LOADING_GYM_SUBSCRIPTION",
    payload: { data: value },
  };
};

export const setMemberCheckInBookings = (value) => {
  return {
    type: "SET_M_CHECKED_IN_BOOKINGS",
    payload: { data: value },
  };
};

export const setMemberBookingListCount = (value) => {
  return {
    type: "SET_M_BOOKING_LIST_COUNT",
    payload: { data: value },
  };
};

export const setMemberBookingListLimit = (value) => {
  return {
    type: "SET_M_BOOKING_LIST_LIMIT",
    payload: { data: value },
  };
};
export const setMemberBookingListPage = (value) => {
  return {
    type: "SET_M_BOOKING_LIST_PAGE",
    payload: { data: value },
  };
};
export const setMembersData = (value) => {
  return {
    type: SET_MEMBERS_DATA,
    payload: { data: value },
  };
};
export const setCheckinsData = (value) => {
  return {
    type: "SET_CHECKINS_DATA",
    payload: { data: value },
  };
};
export const resetCheckinsData = (value) => {
  return {
    type: "RESET_CHECKINS_DATA",
  };
};
export const setMemberInfo = (value) => {
  return {
    payload: { data: value },
    type: "SET_MEMBER_INFO",
  };
};
export const seTransferedToMember = (value) => {
  return {
    payload: { data: value },
    type: "SET_TRANSFERED_TO_MEMBER",
  };
};
export const setMemberPaidJoiningFees = (value) => {
  return {
    payload: { data: value },
    type: "SET_MEMBER_PAID_JOINING_FEE",
  };
};

export const setFreezeAllModalOpen = (value) => {
  return {
    payload: { data: value },
    type: "SET_FREEZE_ALL_MODAL_OPEN",
  };
};
export const setPushNotificationModal = (value) => {
  return {
    payload: { data: value },
    type: "SET_PUSH_NOTIFCATION_MODAL_OPEN",
  };
};
export const setPushNotificationResult = (value) => {
  return {
    payload: { data: value },
    type: "SET_PUSH_NOTIFCATION_MODAL_RESULT",
  };
};

export const setFreezeMembershipOpen = (value) => {
  return {
    payload: { data: value },
    type: "SET_FREEZE_MEMBERSHIP_MODAL_OPEN",
  };
};
export const setVoidMembershipOpen = (value) => {
  return {
    payload: { data: value },
    type: "SET_VOID_MEMBERSHIP_MODAL_OPEN",
  };
};
export const setReturnVoidMembershipOpen = (value) => {
  return {
    payload: { data: value },
    type: "SET__RETURN_VOID_MEMBERSHIP_MODAL_OPEN",
  };
};
export const setReturnProductOpen = (value) => {
  return {
    payload: { data: value },
    type: "SET_RETURN_PRODUCT_OPEN",
  };
};
export const setVoidSummaryOpen = (value) => {
  return {
    payload: { data: value },
    type: "SET_VOID_SUMMARY_MODAL_OPEN",
  };
};

export const setVoidInfo = (value) => {
  return {
    payload: { data: value },
    type: "SET_VOID_INFO",
  };
};
export const setmemberDocuments = (value) => {
  return {
    payload: { data: value },
    type: "SET_DOCUMENTS_INFO",
  };
};
export const setMemberGymSubscriptionPage = (value) => {
  return {
    payload: { data: value },
    type: "SET_MEMBER_GYM_SUBSCRIPTIONS_PAGE",
  };
};
export const setMemberGymSubscriptionLimit = (value) => {
  return {
    payload: { data: value },
    type: "SET_MEMBER_GYM_SUBSCRIPTIONS_LIMIT",
  };
};
export const setMemberMemberSubscriptionsList = (value) => {
  return {
    payload: { data: value },
    type: "SET_MEMBER_GYM_SUBSCRIPTIONS_LIST",
  };
};
export const setMemberMemberSubscriptionsCount = (value) => {
  return {
    payload: { data: value },
    type: "SET_MEMBER_GYM_SUBSCRIPTIONS_COUNT",
  };
};

export const setSharedWithSubscriptions = ( sharedWith, mainSubsription ) => {
  console.log({sharedWith, mainSubsription})
  return {
    payload: { data: sharedWith, mainSubsription },
    type: "SET_MEMBER_SHARED_SUBSCRIPTIONS_WITH",
  };
};
export const setShowSharedWithModal = (value) => {
  return {
    payload: { data: value },
    type: "SET_SHOW_MEMBER_SHARED_SUBSCRIPTIONS_MODAL",
  };
};
export const setCurrentSharedSale = (value) => {
  return {
    payload: { data: value },
    type: "SET_CURRENT_MEMBER_SHARED_SUBSCRIPTION",
  };
};
export const setMemberFreezeHistory = (value) => {
  return {
    type: "SET_MEMBER_FREEZE_HISTORY",
    payload: { data: value },
  };
};
export const setShowMemberFreezeHistory = (value) => {
  return {
    type: "SET_MEMBER_FREEZE_HISTORY_SALE_ID",
    payload: { data: value },
  };
};

/**
{
    "pricePerSession": 4.310344827586207,
    "remainingSessions": 12,
    "usedSessions": 0,
    "deferredAmount": 51.72413793103449,
    "usedAmount": 0
}
 
 
 
 */
